import React, { useEffect, useState } from "react";
import AttachmentsUpload from "../../../../components/common/AttachmentsUpload";
import Notes from "../../../../components/common/Notes";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";
import {
  DatePicker,
  Form,
  Input,
  Select,
  Button,
  Col,
  Row,
  Card,
  Checkbox,
  message,
} from "antd";
import { states, salutations, applicantType } from "../../../../utils/Util";
import ResidentalHistory from "../Components/ResidentalHistory";
import BankAccounts from "../Components/BankAccounts";
import CreditCard from "../Components/CreditCard";
import AdditionalIncome from "../Components/AdditionalIncome";
import Dependents from "../Components/Dependents";
import Pets from "../Components/Pets";
import Questions from "../Components/Questions";
import FormAction from "../../../../components/common/FormAction";
import VacantUnitModal from "./components/VacantUnitModal";
import { createNewRentalApplication } from "./RentalApplicationFirebase";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import Emails from "../Components/Emails";
import PhoneNumbers from "../Components/PhoneNumbers";
const { TextArea } = Input;
const { Option } = Select;

const NewRentalApplicationRightBar = [RightBarMethod("", "t1", "", [])];

function NewRentalApplication() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [disableMiddleName, setDisableMiddleName] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const [propertySelect, setPropertySelect] = useState([]);
  const [emails, setEmails] = useState([{ id: 1, email: "" }]);
  const [pets, setPets] = useState([
    { id: 1, name: "", type: "", weight: "", age: "" },
  ]);
  const [dependents, setDependents] = useState([
    { id: 1, firstName: "", lastName: "", relationship: "", dateOfBirth: "" },
  ]);
  const [creditCards, setCreditCards] = useState([
    { id: 1, issuer: "", balance: "" },
  ]);
  const [additionalIncome, setAdditionalIncome] = useState([
    { id: 1, monthlyIncome: "", source: "" },
  ]);
  const [bankAccounts, setBankAccounts] = useState([
    { id: 1, name: "", accountType: "", accountNumber: "", balance: "" },
  ]);
  const [phoneNumbers, setPhoneNumbers] = useState([
    { id: 1, phoneNumber: "", type: "" },
  ]);
  const [previousAddresses, setPreviousAddresses] = useState([
    {
      id: 1,
      addressOne: "",
      addressTwo: "",
      city: "",
      state: "",
      zipCode: "",
      country: "",
      residedFrom: "",
      residedTo: "",
      monthlyRent: "",
      lanlordName: "",
      lanlordPhoneNumber: "",
      landlordEmailAddress: "",
      reasonForLeaving: "",
    },
  ]);

  const [notes, setNotes] = useState([]);
  const [fileList, setFileList] = useState([]);
  const navigate = useNavigate();

  const showModal = () => {
    setIsModalOpen(true);
    //console.log("modal", isModalOpen)
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const [files, setFiles] = useState([]);

  const onFinish = (values) => {
    //console.log(values, "Datatatatatttat")
    const phNumbers = phoneNumbers.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });
    const mails = phoneNumbers.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });
    const prevAddresses = previousAddresses.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });
    const pet = pets.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });
    const dep = dependents.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });
    const creditCard = creditCards.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });
    const addIncome = additionalIncome.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });
    const bankAccount = bankAccounts.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });
    const filteredNotes = notes.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });

    try {
      createNewRentalApplication(
        values,
        companyName,
        mails,
        phNumbers,
        prevAddresses,
        pet,
        dep,
        creditCard,
        addIncome,
        bankAccount,
        filteredNotes,
        files
      ).then(() => {
        message.success("New Rental Application Created SuccessFully!", 2);
        navigate("/leasing/rental-applications");
      });
    } catch (err) {
      message.error(err.message);
    }
  };

  const onFinishFailed = (errr) => {
    //console.log("failed", errr);
    message.error("New Rental Application Creation Failed!");
  };
  const handleCancel = () => {
    navigate("/leasing/rental-applications");
  };

  useEffect(() => {
    if (companyName) {
      const fetchProperties = async () => {
        try {
          const propertyGroupRef = collection(
            db,
            "companies",
            companyName,
            "properties"
          );
          const snapshot = await getDocs(propertyGroupRef);
          const fetchedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            label: doc.data().propertyNameAddress.propertyName,
            value: doc.id,
            ...doc.data(),
          }));
          setPropertySelect(fetchedData);
        } catch (err) {
          console.error(err);
          alert(err.message);
        }
      };
      fetchProperties();
    }
  }, [companyName]);

  return (
    <>
      <PageHeading heading="New Rental Application" />
      <Form
        name="basic"
        labelCol={{ span: 7 }}
        initialValues={{ remember: true }}
        autoComplete="off"
        className="form-container"
        colon={false}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[0, 24]}>
          <Col span={24}>
            {/* First Card */}

            <Card>
              <Form.Item
                name="unit"
                label="Unit"
                rules={[
                  {
                    required: true,
                    message: "Please select Unit!",
                  },
                ]}
                wrapperCol={{ span: 8 }}
              >
                {/* <Select showSearch allowClear options={propertyTypes} /> */}

                <Select showSearch allowClear options={propertySelect} />
              </Form.Item>

              {/* <Form.Item label="    " wrapperCol={{ span: 8 }}>
                <Button
                  type="link"
                  style={{ paddingLeft: "0px" }}
                  onClick={showModal}
                >
                  Browse Vacant Units
                </Button>
              </Form.Item> */}

              {/* <VacantUnitModal visible={isModalOpen} onClose={closeModal} /> */}

              <Form.Item
                name="VacantDate"
                label="Vacant Date"
                wrapperCol={{ span: 8 }}
              >
                <p>--</p>
              </Form.Item>

              <Form.Item
                name="desiredMoveIn"
                label="Desired Move In"
                rules={[
                  {
                    required: true,
                    message: "Please Select date of Desired Move In!",
                  },
                ]}
                wrapperCol={{ span: 8 }}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Card>

            <br />

            {/* 2nd Card */}
            <Card>
              <Form.Item
                label="Salutation"
                name="salutation"
                wrapperCol={{ span: 8 }}
              >
                <Select>
                  {salutations.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="legalFirstName"
                label="Legal First Name"
                rules={[
                  {
                    required: true,
                    message: "Please enter your First name!",
                  },
                ]}
                wrapperCol={{ span: 8 }}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="middleName"
                label="Middle Name"
                wrapperCol={{ span: 8 }}
              >
                <Input disabled={disableMiddleName} />
              </Form.Item>

              <Form.Item
                wrapperCol={{ span: 8 }}
                label="I certify the applicant did not provide a middle name"
                name="noMiddleName"
                valuePropName="checked"
              >
                <Checkbox
                  onClick={() => setDisableMiddleName(!disableMiddleName)}
                ></Checkbox>
              </Form.Item>

              <Form.Item
                name="lastName"
                label="Last Name"
                rules={[
                  {
                    required: true,
                    message: "Please enter your last name!",
                  },
                ]}
                wrapperCol={{ span: 8 }}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="suffixes"
                label="Suffixes"
                wrapperCol={{ span: 8 }}
              >
                <Input placeholder="Jr, Sr, III, IV" />
              </Form.Item>

              <Form.Item
                label="Applicant Type"
                name="applicantType"
                wrapperCol={{ span: 8 }}
              >
                {/* <Select options={applicantType} /> */}
                <Select>
                  {applicantType.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Company Name"
                name="companyName"
                wrapperCol={{ span: 8 }}
              >
                <Input />
              </Form.Item>

              <Form.Item
                wrapperCol={{ span: 8 }}
                label="Use Company Name as display name"
                name="useCompanyName"
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>

              <h4 style={{ fontSize: 13, marginBottom: 20 }}>Phone Numbers</h4>

              <PhoneNumbers
                phoneNumbers={phoneNumbers}
                setPhoneNumbers={setPhoneNumbers}
              />

              <h4 style={{ fontSize: 13, marginBottom: 20 }}>Emails</h4>

              <Emails emails={emails} setEmails={setEmails} />
            </Card>

            <br />

            {/* RESIDENTIAL HISTORY */}

            <Card title="Residential History" bordered={false}>
              <ResidentalHistory
                previousAddresses={previousAddresses}
                setPreviousAddresses={setPreviousAddresses}
              />
            </Card>

            <br />

            {/* PERSONAL INFORMATION */}

            <Card title="Personal Information" bordered={false}>
              <Form.Item
                name="dob"
                label="Date of Birth"
                rules={[
                  {
                    required: true,
                    message: "Please enter your Date of Birth!",
                  },
                ]}
                wrapperCol={{ span: 8 }}
              >
                <Input placeholder="MM/DD/YYYY" />
              </Form.Item>

              <Form.Item
                name="ssn"
                label="SSN (or ITIN)"
                rules={[
                  {
                    required: true,
                    message: "Please enter SSN!",
                  },
                ]}
                wrapperCol={{ span: 8 }}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="govId"
                label="Government Issued ID"
                wrapperCol={{ span: 8 }}
              >
                <Input placeholder="Numbber" />
              </Form.Item>

              <Form.Item
                name="issuingTerritory"
                label="Issuing State/Territory"
                wrapperCol={{ span: 8 }}
              >
                <Select options={states} />
              </Form.Item>
            </Card>
            <br />

            {/* FINANCIAL INFORMATION */}

            <Card title="Financial Information" bordered={false}>
              <h4 style={{ fontSize: 13, marginBottom: 20 }}>Bank Accounts</h4>

              <Row style={{ marginBottom: 8 }}>
                <Col className="tableHead" span={6}>
                  <p>Name</p>
                </Col>
                <Col className="tableHead" span={6}>
                  <p>Account Type</p>
                </Col>
                <Col className="tableHead" span={6}>
                  <p>Account Number</p>
                </Col>
                <Col className="tableHead" span={5}>
                  <p>Balance</p>
                </Col>
                <Col span={1}></Col>
              </Row>

              <BankAccounts
                bankAccounts={bankAccounts}
                setBankAccounts={setBankAccounts}
              />

              <h4 style={{ fontSize: 13, marginBottom: 20 }}>Credit Cards</h4>

              <Row style={{ marginBottom: 8 }}>
                <Col className="tableHead" span={18}>
                  <p>Issuer</p>
                </Col>
                <Col className="tableHead" span={5}>
                  <p>Balance</p>
                </Col>
                <Col span={1}></Col>
              </Row>

              <CreditCard
                creditCards={creditCards}
                setCreditCards={setCreditCards}
              />
            </Card>
            <br />

            {/* INCOME */}

            <Card title="Income" bordered={false}>
              <Card title="Employment Details" bordered={false}>
                <Form.Item
                  name="employerName"
                  label="Employer Name"
                  wrapperCol={{ span: 8 }}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  name="employerPhone"
                  label="Employer Phone Number"
                  wrapperCol={{ span: 8 }}
                >
                  <Input />
                </Form.Item>

                <Form.Item name="employerAddress1" label="Employer Address">
                  <Input placeholder="Address 1" />
                </Form.Item>

                <Form.Item label=" " name="employerAddress2">
                  <Input placeholder="Address 2" />
                </Form.Item>

                <Form.Item label="">
                  <Row>
                    <Col flex={10}>
                      <Form.Item label="  " name="employerCity">
                        <Input placeholder="City" />
                      </Form.Item>{" "}
                    </Col>
                    <Col flex={1}></Col>
                    <Col flex={2}>
                      <Form.Item label="    " name="employerState">
                        <Select options={states} />
                      </Form.Item>
                    </Col>
                    <Col flex={1}></Col>
                    <Col flex={2}>
                      <Form.Item label="  " name="employerZip">
                        <Input placeholder="Zip" />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form.Item>
                <Form.Item
                  name="employerCountry"
                  label="  "
                  // rules={[{ required: true }]}
                >
                  <Input placeholder="Country" />
                </Form.Item>
                <Form.Item
                  name="employerMonthlySalary"
                  label="Monthly Salary"
                  wrapperCol={{ span: 8 }}
                >
                  <Input prefix="$" />
                </Form.Item>
                <Form.Item
                  name="employerPositionHeld"
                  label="Position Held"
                  wrapperCol={{ span: 8 }}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="employerYearsWorked"
                  label="Number of Years Worked"
                  wrapperCol={{ span: 8 }}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="employerSupervisorName"
                  label="Supervisor Name"
                  wrapperCol={{ span: 8 }}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="employerSupervisorTitle"
                  label="Supervisor Title"
                  wrapperCol={{ span: 8 }}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="SupervisorEmail"
                  label="Supervisor Email Address"
                  wrapperCol={{ span: 8 }}
                >
                  <Input />
                </Form.Item>
              </Card>
              <br />
              <Card title="Additional Income" bordered={false}>
                <Row style={{ marginBottom: 8 }}>
                  <Col className="tableHead" span={8}>
                    <p>Monthly Income</p>
                  </Col>
                  <Col className="tableHead" span={15}>
                    <p>Source</p>
                  </Col>
                  <Col span={1}></Col>
                </Row>
                <AdditionalIncome
                  additionalIncome={additionalIncome}
                  setAdditionalIncome={setAdditionalIncome}
                />
              </Card>
            </Card>
            <br />

            {/* DEPENDENT */}

            <Card title="Dependent" bordered={false}>
              <Row style={{ marginBottom: 8 }}>
                <Col className="tableHead" span={6}>
                  <p>First Name</p>
                </Col>
                <Col className="tableHead" span={6}>
                  <p>Last Name</p>
                </Col>
                <Col className="tableHead" span={6}>
                  <p>Relationship</p>
                </Col>
                <Col className="tableHead" span={5}>
                  <p>Date Of Birth</p>
                </Col>
                <Col span={1}></Col>
              </Row>
              <Dependents
                dependents={dependents}
                setDependents={setDependents}
              />
            </Card>
            <br />

            {/* PETS */}

            <Card title="Pets" bordered={false}>
              <Row style={{ marginBottom: 8 }}>
                <Col className="tableHead" span={8}>
                  <p>Pet's Name</p>
                </Col>
                <Col className="tableHead" span={8}>
                  <p>Type/Breed</p>
                </Col>
                <Col className="tableHead" span={4}>
                  <p>{"Weight (lbs)"}</p>
                </Col>
                <Col className="tableHead" span={3}>
                  <p>Age</p>
                </Col>
                <Col span={1}></Col>
              </Row>
              <Pets pets={pets} setPets={setPets} />
            </Card>
            <br />

            {/* EMERGENCY CONTACT */}

            <Card title="Emergency Contact" bordered={false}>
              <Form.Item
                name="emergencyName"
                label="Name"
                wrapperCol={{ span: 8 }}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="emergencyAddress"
                label="Address"
                wrapperCol={{ span: 8 }}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="emergencyPhone"
                label="Phone Number"
                wrapperCol={{ span: 8 }}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="emergencyEmail"
                label="Email Address"
                wrapperCol={{ span: 8 }}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="emergencyRelationShip"
                label="Relationship"
                wrapperCol={{ span: 8 }}
              >
                <Input />
              </Form.Item>
            </Card>
            <br />

            {/* QUESTIONS */}

            <Card title="Questions" bordered={false}>
              <Questions />
            </Card>

            <br />
            <Col span={24}>
              {companyName ? (
                <Notes
                  notesForCollection="rentalApplications"
                  notesForCollectionId=""
                  companyName={companyName}
                  notes={notes}
                  setNotes={setNotes}
                />
              ) : null}
            </Col>
            <br />
            <Col span={24}>
              <AttachmentsUpload setFiles={setFiles} />
            </Col>
            <br />
            <FormAction submit="submit" cancel={handleCancel} />

            <br />
          </Col>
        </Row>
      </Form>

      <div className="RightSidebar">
        <RightBar RightBarData={NewRentalApplicationRightBar} />
      </div>
    </>
  );
}

export default NewRentalApplication;
